import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SummaryType } from 'src/app/shared/model/summary-type';

@Component({
  selector: 'app-summary-settings-dialog',
  templateUrl: './summary-settings-dialog.component.html',
  styleUrls: ['./summary-settings-dialog.component.scss']
})
export class SummarySettingsDialogComponent {

  constructor(public ref: MatDialogRef<SummarySettingsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: SummaryType) { }

  close(type: SummaryType): void {
    this.ref.close(type);
  }

}
